<template>
  <div>
    <v-snackbar absolute top :timeout="3000" v-model="snackbar">
      {{ snackbarText }}
    </v-snackbar>

    <v-card>
      <v-card-title class="grid-close">
        <span class="headline">Multifactor de autenticación </span>
        <v-btn
          style="right: 10px; top: 10px"
          icon
          color="primary"
          fab
          absolute
          @click="$emit('cancel')"
        >
          <v-icon dark>fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-row v-if="auth && auth.hints.length" class="pa-4">
                <v-col
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  class="pl-2"
                  cols="2"
                  sm="2"
                  md="2"
                >
                  <i
                    style="font-size: 60px; color: #929191"
                    class="fas fa-sms"
                  />
                </v-col>

                <v-col cols="10" sm="10" md="10">
                  <p
                    class="font-weight-bold mb-5"
                    style="color: #5c5c5c; text-align: justify"
                  >
                    <span>
                      Este usuario tiene activado el multifactor de
                      autenticación, se ha enviado el código de verificación al
                      número
                      {{ auth.hints[0].phoneNumber }}.</span
                    >
                  </p>
                </v-col>
              </v-row>
              <div class="ma-auto position-relative" style="max-width: 400px">
                <v-otp-input
                  length="6"
                  @finish="next"
                  v-model="otp"
                  :disabled="loading"
                ></v-otp-input>

                <v-overlay color="white" absolute :value="loading">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-overlay>
              </div>
            </v-col>

            <!-- <v-col class="mb-0 pb-0" cols="12" sm="12" md="12">
              <v-btn
                @click="next"
                height="50"
                rounded
                block
                :loading="loading"
                :disabled="!otp"
                color="primary"
                >Verificar</v-btn
              >
            </v-col> -->
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
    
    <script>
import { mapState } from "vuex";

export default {
  name: "MFA-code",
  props: ["auth"],
  components: {},
  data() {
    return {
      snackbar: false,
      snackbarText: "",
      otp: "",
      loading: false,
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    onFinish(e) {
     console.log(e);
    },
    next() {
      this.$emit("success", this.otp);
      this.loading = true;
    },
    error() {
      this.snackbarText = "Código de verificación incorrecto.";
      this.snackbar = true;
      this.loading = false;
      this.otp = "";
    },
  },
  mounted() {
    //console.log(this.auth.hints[0].phoneNumber);
  },
};
</script>


<style lang="scss">
.position-relative {
  position: relative;
}
</style>
    
  